import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { glensFallsConfig } from "./data";

export default function GlensFallsPage() {
  return <CityPageTemplate config={glensFallsConfig} />;
}